/** 发布与处理分开展示；未知处理结果不能推断成全部完成。 */
export function resourceListStatus(row = {}) {
  const code = Number(row.onOrOff)
  const publication = code === 1
    ? { label: '上线', variant: 'online' }
    : [0, 10, 11, 12].includes(code)
      ? { label: '下线', variant: 'offline' }
      : { label: '未知', variant: 'offline' }
  if ((row.assetType || row.wallpaperType) === 'stickers') {
    const summary = row.processingStatus
    const states = ['done', 'pending', 'paused', 'partial', 'failed', 'unknown']
    const processing = summary && states.includes(summary.state) && typeof summary.message === 'string' && summary.message
      ? { state: summary.state, message: summary.message, error: summary.error || '' }
      : { state: 'unknown', message: '状态未读取', error: '处理状态暂不可用，请刷新列表后重试。' }
    return { publication, processing }
  }
  const legacy = { 10: ['pending', '处理中'], 11: ['failed', '处理失败'], 12: ['pending', '等待重试'] }[code]
  return { publication, processing: legacy ? { state: legacy[0], message: legacy[1], error: '' } : null }
}
